import { labelChipSizes } from '../../../chips';
import { classNamesFor } from '../../../../utils/classNames';

const factory = classNamesFor('TendencyLabelChip');

export const tendencyLabelChipClassNames = {
  root: factory.root(),
  ...factory.toAttrClasses('tendency', ['up', 'down', 'stable'] as const),
  ...factory.toAttrClasses('iconPlacement', ['start', 'end'] as const),
  ...factory.toAttrClasses('size', labelChipSizes),
  upIsPositive: factory.attribute('upIsPositive'),
};
